import type { Person } from '../../shared/organisation.ts';

/**
 * Somebody's face: their Google photo, else their initials on a neutral disc.
 *
 * Deliberately NOT tinted with their swatch. A swatch is what tells two owners
 * apart in a list of decks; here the name is right beside the disc, so colour
 * separates nobody and would spend a second saturated hue on chrome.
 *
 * `referrerPolicy` stops Google's CDN refusing the image on networks that strip
 * or rewrite the referrer. The alt is empty because every caller puts the name
 * in text next to it or on the control that wraps it.
 */
export default function PersonAvatar({ person, size = 26 }: { person: Person | null; size?: number }) {
  const style = { width: size, height: size };
  if (person?.picture) {
    return (
      <img
        className="person-avatar"
        style={style}
        src={person.picture}
        alt=""
        referrerPolicy="no-referrer"
        width={size}
        height={size}
      />
    );
  }
  return (
    <span className="person-avatar person-avatar--initials" style={style} aria-hidden="true">
      {person?.initials ?? '·'}
    </span>
  );
}
